// React
import PropTypes from "prop-types";

// Functions
import isEmpty from "../../validation/is-empty";
import { tranStr } from "../../utils/translation";

// Style
import "./CheckboxesVertical.css";

CheckboxesVertical.propTypes = {
  array: PropTypes.array,
  setFunction: PropTypes.func,
  selection: PropTypes.array,
  maxSelectionSize: PropTypes.number,
  minSelectionSize: PropTypes.number,
};

export default function CheckboxesVertical(props) {
  const { array, setFunction, selection } = props;
  const { maxSelectionSize } = props;
  const { minSelectionSize } = props;

  if (isEmpty(array)) {
    return null;
  }

  return (
    <div className="checkboxes-vertical">
      {array?.map((item, i) => {
        return (
          <label key={i} className="checkboxes-vertical-container">
            <div className="checkbox-label">{item.label}</div>
            <input
              key={i}
              type="checkbox"
              name={item.value}
              value={item.value}
              checked={selection.some((e) => e.value === item.value)}
              onChange={(e) => {
                const selected = {
                  label: tranStr(e.target.name),
                  value: e.target.name,
                };
                const checked = e.target.checked;

                checkFunction(
                  checked,
                  maxSelectionSize,
                  minSelectionSize,
                  selection,
                  setFunction,
                  selected
                );
              }}
            />
            <span className="checkmark"></span>
          </label>
        );
      })}
    </div>
  );
}

function checkFunction(
  checked,
  maxSelectionSize,
  minSelectionSize,
  selection,
  setFunction,
  selected
) {
  // If checking this option
  if (checked) {
    // If a max size is provided return if this will exceed the max size
    if (maxSelectionSize && selection.length >= maxSelectionSize) {
      return;
    }

    // Set the locations to current selection + the selected
    setFunction((selectedItems) => [...selectedItems, selected]);
  }

  // If unchecking the option
  if (!checked) {
    // If a max size is provided return if this will exceed the min size
    if (minSelectionSize && selection.length <= minSelectionSize) {
      return;
    }

    // Set the locations to the current selection
    setFunction((selectedItems) =>
      // Filtering out the seleted
      selectedItems.filter((x) => x.value !== selected.value)
    );
  }
}
